var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "w-full" },
    [
      _c("tr", [
        _c("td", { staticClass: "font-semibold" }, [
          _vm._v(_vm._s(_vm.event.name)),
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "text-center" }, [_vm._v(_vm._s(_vm.seats))]),
        _vm._v(" "),
        _c("td", { staticClass: "text-right" }, [
          _vm._v(
            "£" +
              _vm._s(
                (_vm.event.formatted_price * _vm.seats).toLocaleString(
                  undefined,
                  { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                )
              )
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.selectedAddOns, function (addon) {
        return [
          _vm.hasOptionSelected(addon)
            ? [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "font-semibold pt-2",
                      attrs: { colspan: "3" },
                    },
                    [_vm._v(_vm._s(addon.name))]
                  ),
                ]),
                _vm._v(" "),
                addon.applies_to_group
                  ? _c("tr", [
                      _c("td", { staticClass: "text-gray-600" }, [
                        _vm._v(_vm._s(_vm.nameOfOption(addon.value))),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _vm._v(_vm._s(_vm.seats)),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          "£" +
                            _vm._s(
                              (
                                _vm.seats * _vm.priceForOption(addon.value)
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            )
                        ),
                      ]),
                    ])
                  : _vm._l(addon.value, function (option) {
                      return option.value > 0
                        ? _c("tr", [
                            _c("td", { staticClass: "text-gray-500" }, [
                              _vm._v(
                                _vm._s(_vm.nameOfOption(option.option_id))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(_vm._s(option.value)),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                "£" +
                                  _vm._s(
                                    (
                                      option.value *
                                      _vm.priceForOption(option.option_id)
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e()
                    }),
              ]
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("tr", [
        _c(
          "td",
          { staticClass: "font-semibold pt-3 border-t border-gray-200" },
          [_vm._v("Total")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticClass:
              "text-right font-semibold pt-3 border-t border-gray-200",
            attrs: { colspan: "2" },
          },
          [_vm._v("£" + _vm._s(_vm.total))]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "pb-4", attrs: { colspan: "3" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }